const DISPLAY_LOCALE = "en-US";

const CALENDAR_DATE_FORMAT = new Intl.DateTimeFormat(DISPLAY_LOCALE, { timeZone: "UTC" });

/** Date-only ISO strings parse as UTC midnight, so formatting in UTC keeps the intended calendar day. */
export const formatCalendarDate = (isoDate: string): string => {
  const timestamp = Date.parse(isoDate);
  return Number.isNaN(timestamp) ? "" : CALENDAR_DATE_FORMAT.format(timestamp);
};

const DAY_MONTH_YEAR_FORMAT = new Intl.DateTimeFormat(DISPLAY_LOCALE, {
  day: "2-digit",
  month: "short",
  year: "numeric",
});

export const formatDayMonthYear = (date: Date): string => {
  const parts = Object.fromEntries(
    DAY_MONTH_YEAR_FORMAT.formatToParts(date).map(({ type, value }) => [type, value])
  );
  return `${parts.day}-${parts.month}, ${parts.year}`;
};
